<footer class="bg-primary footer">
    <!-- <div fxLayout="column" fxLayout.gt-sm="row wrap" fxLayoutAlign="center center" class="border-bottom-mute subscribe-block theme-container">
        <div fxFlex="100" fxFlex.gt-sm="40" fxLayout="column" fxLayoutAlign="center center"> 
            <h1 class="fw-500">Subscribe our Newsletter</h1>
            <h3 class="fw-300 secondary-color">Stay up to date with our latest new and products</h3>
        </div>
        <form method="get" class="subscribe-search-form" fxLayout="row" fxFlex="100" fxFlex.gt-sm="42.4" ngClass.sm="mt-2" ngClass.xs="mt-2">
            <input type="text" placeholder="Your email address..." fxFlex>
            <button mat-raised-button color="accent" (click)="subscribe()" type="button" class="mat-elevation-z0 text-muted">Subscribe</button>
        </form>
    </div> -->
    <div fxLayout="row wrap" fxLayoutAlign="space-between" class="py-3 border-bottom-mute theme-container">
        <div fxFlex="100" fxFlex.gt-sm="20" fxFlex.sm="40">
            <h3 class="col-title">USEFUL LINKS</h3>
            <p class="mt-2"><a routerLink="/account/dashboard" class="link secondary-color">My Account</a></p>
            <p class="mt-1"><a routerLink="/contact" class="link secondary-color">Contact</a></p>
            <!-- <p class="mt-1"><a routerLink="/compare" class="link secondary-color">Compare</a></p>
            <p class="mt-1"><a routerLink="/wishlist" class="link secondary-color">Wishlist</a></p>
            <p class="mt-1"><a routerLink="/checkout" class="link secondary-color">Checkout</a></p>
            <p class="mt-1"><a href="javascript:void(0);" class="link secondary-color">FAQ</a></p> -->
        </div>
        <div fxFlex="100" fxFlex.gt-sm="30" fxFlex.sm="60" ngClass.xs="mt-2" class="contact-information">
            <h3 class="col-title">CONTACT INFORMATION</h3>
            <p fxLayout="row" fxLayoutAlign="start center" class="mt-2 secondary-color">
                <mat-icon>location_on</mat-icon>
                <span>Office No. 302, 3rd Floor,
                    Konark Icon, S. No. 134, Hissa No. 1D, Magarpatta City Road,
                    Pune, India - 411028</span>
            </p>
            <!-- <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
                <mat-icon>call</mat-icon>
                <span>(212) 457-2308</span>
            </p> -->
            <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
                <mat-icon>mail_outline</mat-icon>
                <a style="color:#eaecbf;text-decoration: none;" href="mailto:connect@akshaya-agri.com">
                    <span> connect@akshaya-agri.com </span>
                </a>
            </p>
            <!-- <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
                <mat-icon>schedule</mat-icon>
                <span>Mon - Sun / 9:00AM - 8:00PM</span>
            </p> -->
            <!-- <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
                <mat-icon>directions</mat-icon>
                <a href="javascript:void(0);" class="link secondary-color">Get directions</a>
            </p>
            <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
                <mat-icon>directions_bus</mat-icon>
                <span>Routes to us</span>
            </p> -->
        </div>
        <!-- <div fxFlex="100" fxFlex.gt-sm="50" ngClass.sm="mt-2" ngClass.xs="mt-2">
            <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" [mapTypeControl]="true">
                <agm-marker [latitude]="lat" [longitude]="lng" [markerDraggable]="true"></agm-marker>
            </agm-map>
        </div> -->
    </div>
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center"
        class="copyright secondary-color theme-container">
        <p ngClass.xs="mt-1">Copyright © 2021 All Rights Reserved</p>
        <p>Designed & Developed by <a mat-button href="http://www.meshbaco.com/" target="_blank">MeshBA Solutions </a>
        </p>
    </div>
</footer>